/** Canonical color palette for sticky card background pickers. */
export const COLORS = [
  "#4dff6a",
  "#2d8644",
  "#90bb9b",
  "#cce0d1",
  "#4ce6ff",
  "#2265c3",
  "#93b8ec",
  "#bad1f3",
  "#ff914c",
  "#f98006",
  "#fba651",
  "#fdd9b4",
  "#ffff54",
  "#ddb929",
  "#f3d459",
  "#fff5ae",
  "#ff0000",
  "#d22d2d",
  "#e06c6c",
  "#ecac9e",
  "#684cff",
  "#915cd6",
  "#b6acea",
  "#d0cae3",
  "#1c1e21",
  "#afb2ba",
  "#dee0e3",
  "#ffffff",
];
